export default "__VITE_ASSET__CroIvm12__"